import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Actions } from '../DataBox.styles';

export default function DataBoxActions({ children, testId = 'data-box-actions' }: IDataBox) {
  return <Actions data-testid={testId}>{children}</Actions>;
}
